import { render, staticRenderFns } from "./colourEditor.vue?vue&type=template&id=9a00a666&scoped=true"
import script from "./colourEditor.vue?vue&type=script&lang=js"
export * from "./colourEditor.vue?vue&type=script&lang=js"
import style0 from "./colourEditor.vue?vue&type=style&index=0&id=9a00a666&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a00a666",
  null
  
)

export default component.exports